import ApplicantQualificationReviewModal from './ApplicantQualificationReviewModal';

export default ApplicantQualificationReviewModal;
